import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon } from 'lucide-react';
import { demoPhone } from '../../data/websites';
import { LiveChangeDemo } from './LiveChangeDemo';
export function WebsitesHero() {
  return <section className="overflow-hidden bg-white px-[clamp(1rem,4vw,6rem)] pb-20 pt-14 lg:pb-28 lg:pt-20" data-id="element-1105" data-mp="1ck6ryrfarzt2">
      <div className="grid items-center gap-14 lg:grid-cols-2 xl:gap-20" data-id="element-1106" data-mp="1hd9on8fdfpdh">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-1107" data-mp="1mbjmxrwe763b">
          <p className="text-sm font-bold uppercase tracking-[0.14em] text-brand-red" data-id="element-1108" data-mp="1vay94f5j0ui0">Websites That Run Themselves</p>
          <h1 className="mt-5 max-w-[18ch] text-[clamp(2.5rem,3.6vw,4.25rem)] font-extrabold leading-[1.04] tracking-tight text-brand-black" data-id="element-1109" data-mp="20asxaaxx35zd">
            Your website, changed in minutes. <span className="text-brand-red" data-id="element-1110" data-mp="5w9v69haf4hv">Just say what you want.</span>
          </h1>
          <p className="mt-6 max-w-[60ch] text-[clamp(1.0625rem,1.2vw,1.375rem)] leading-relaxed text-gray-600" data-id="element-1111" data-mp="3ei87hx8amoak">
            Tell us the change the way you’d tell a person: by phone, text, email, Slack or online. It’s live on your real
            website within minutes, and we check your live site before we tell you it’s done.
          </p>
          <div className="mt-9 flex flex-col gap-4 sm:flex-row" data-id="element-1112" data-mp="30s4qbko9tkrz">
            <a href={demoPhone.tel} className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-brand-red px-8 py-4 text-lg font-bold text-white shadow-lg transition-colors duration-150 ease-out hover:bg-brand-red-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-red focus-visible:ring-offset-2" data-id="element-1113" data-mp="1bgbgl0ssirb">
              <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-1114" data-mp="2d1902rzgqxmu" />
              Try it now: {demoPhone.display}
            </a>
            <a href="#/contact" className="inline-flex items-center justify-center whitespace-nowrap rounded-md border-2 border-gray-200 bg-white px-8 py-4 text-lg font-bold text-gray-700 transition-colors duration-150 ease-out hover:border-brand-black hover:text-brand-black focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-red focus-visible:ring-offset-2" data-id="element-1115" data-mp="281wf6cs5k0mw">
              Talk to us
            </a>
          </div>
          <p className="mt-6 text-sm font-medium text-brand-gray" data-id="element-1116" data-mp="1qt3ohibl0g53">
            No web designer needed. No waiting days. No bill for every little edit.
          </p>
        </motion.div>

        <LiveChangeDemo data-id="element-1117" data-mp="1vldcutx1t859" />
      </div>
    </section>;
}